// Module
var code = "<p class=\"captions\">{{ captionString }}</p>";
// Exports
module.exports = code;